module.exports = __webpack_public_path__ + "static/02_Step-by-step-compressed-9ffaecee7eab4b878223d0b8aa1cc18d.jpg";